import React from "react";
import { SavedContractsProvider } from "../SavedContractsMatrix/state/savedContractsContext";
import { SavedContractsView } from "../SavedContractsMatrix/components/SavedContractsView";

export default function SavedContracts(props) {
  return (
    <SavedContractsProvider>
      <SavedContractsView {...props} />
    </SavedContractsProvider>
  );
}
